import request from '@/router/axios'
import env from '@/config/env'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

// 线下开票分页信息
export const getPage = (data) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/invoice-offline/page',
    method: 'POST',
    timeout: TIME,
    data
  })
}

// 开票
export const postInvoice = (data) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/confirm-issuance-invoice',
    method: 'POST',
    timeout: TIME,
    data
  })
}
